module.exports = __webpack_public_path__ + "img/dice-6-fill.99bb0b5b.svg";